import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const AgentsIncomesFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.agentsIncomes.totalAgentsCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
